"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getVATIdentificationNumberFromOrganisation = exports.getGroupNumberFromOrganisation = exports.VAT_IDENTIFICATION_NUMBER_CODE = exports.GROUP_NUMBER_CODE = exports.REGISTRATION_NUMBER_CODE = exports.organisationPropTypes = exports.identificationNumberPropTypes = exports.interoperatedOrganisationPropTypes = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _country = require("./country");

var _address = require("./address");

var interoperatedOrganisationPropTypes = function interoperatedOrganisationPropTypes() {
  return _propTypes.default.shape({
    masterPlatform: _propTypes.default.string,
    country: _propTypes.default.oneOf(_country.ALL_COUNTRIES),
    enabled: _propTypes.default.bool.isRequired
  });
};

exports.interoperatedOrganisationPropTypes = interoperatedOrganisationPropTypes;

var identificationNumberPropTypes = function identificationNumberPropTypes() {
  return _propTypes.default.shape({
    id: _propTypes.default.number,
    value: _propTypes.default.string,
    code: _propTypes.default.string
  });
};

exports.identificationNumberPropTypes = identificationNumberPropTypes;

var organisationPropTypes = function organisationPropTypes() {
  return _propTypes.default.shape({
    organisationId: _propTypes.default.number.isRequired,
    registrationNumber: _propTypes.default.string.isRequired,
    fullName: _propTypes.default.string.isRequired,
    country: _propTypes.default.oneOf(_country.ALL_COUNTRIES).isRequired,
    address: (0, _address.addressPropTypes)().isRequired,
    enabled: _propTypes.default.bool.isRequired,
    groupId: _propTypes.default.number.isRequired,
    planSelected: _propTypes.default.bool,
    interoperatedOrganisation: interoperatedOrganisationPropTypes(),
    identificationNumbers: _propTypes.default.object
  });
};

exports.organisationPropTypes = organisationPropTypes;
var REGISTRATION_NUMBER_CODE = 'REGISTRATION_NUMBER';
exports.REGISTRATION_NUMBER_CODE = REGISTRATION_NUMBER_CODE;
var GROUP_NUMBER_CODE = 'GROUP_NUMBER';
exports.GROUP_NUMBER_CODE = GROUP_NUMBER_CODE;
var VAT_IDENTIFICATION_NUMBER_CODE = 'VAT_IDENTIFICATION_NUMBER';
exports.VAT_IDENTIFICATION_NUMBER_CODE = VAT_IDENTIFICATION_NUMBER_CODE;

var getGroupNumberFromOrganisation = function getGroupNumberFromOrganisation(organisation) {
  var groupNumberIdentificationNumber = organisation.identificationNumbers[GROUP_NUMBER_CODE];

  if (groupNumberIdentificationNumber) {
    return groupNumberIdentificationNumber;
  }

  return null;
};

exports.getGroupNumberFromOrganisation = getGroupNumberFromOrganisation;

var getVATIdentificationNumberFromOrganisation = function getVATIdentificationNumberFromOrganisation(organisation) {
  var vatIdentificationNumber = organisation.identificationNumbers[VAT_IDENTIFICATION_NUMBER_CODE];

  if (vatIdentificationNumber) {
    return vatIdentificationNumber;
  }

  return null;
};

exports.getVATIdentificationNumberFromOrganisation = getVATIdentificationNumberFromOrganisation;
var organisations = {
  interoperatedOrganisationPropTypes: interoperatedOrganisationPropTypes,
  organisationPropTypes: organisationPropTypes,
  REGISTRATION_NUMBER_CODE: REGISTRATION_NUMBER_CODE,
  GROUP_NUMBER_CODE: GROUP_NUMBER_CODE,
  VAT_IDENTIFICATION_NUMBER_CODE: VAT_IDENTIFICATION_NUMBER_CODE,
  getGroupNumberFromOrganisation: getGroupNumberFromOrganisation,
  getVATIdentificationNumberFromOrganisation: getVATIdentificationNumberFromOrganisation
};
var _default = organisations;
exports.default = _default;
//# sourceMappingURL=organisations.js.map